import { render } from "./CaregiversList.vue?vue&type=template&id=8f9ea6da&ts=true"
import script from "./CaregiversList.vue?vue&type=script&lang=ts"
export * from "./CaregiversList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Caregivers/CaregiversList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f9ea6da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f9ea6da', __exports__)) {
    api.reload('8f9ea6da', __exports__)
  }
  
  module.hot.accept("./CaregiversList.vue?vue&type=template&id=8f9ea6da&ts=true", () => {
    api.rerender('8f9ea6da', render)
  })

}


export default __exports__